// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/components/slider/index.scss
// module id = 948
// module chunks = 0